export default {
  ziweiMaj: '紫微',
  tianjiMaj: '天机',
  taiyangMaj: '太阳',
  wuquMaj: '武曲',
  tiantongMaj: '天同',
  lianzhenMaj: '廉贞',
  tianfuMaj: '天府',
  taiyinMaj: '太阴',
  tanlangMaj: '贪狼',
  jumenMaj: '巨门',
  tianxiangMaj: '天相',
  tianliangMaj: '天梁',
  qishaMaj: '七杀',
  pojunMaj: '破军',
  zuofuMin: '左辅',
  youbiMin: '右弼',
  wenchangMin: '文昌',
  wenquMin: '文曲',
  lucunMin: '禄存',
  tianmaMin: '天马',
  qingyangMin: '擎羊',
  tuoluoMin: '陀罗',
  huoxingMin: '火星',
  lingxingMin: '铃星',
  tiankuiMin: '天魁',
  tianyueMin: '天钺',
  dikongMin: '地空',
  dijieMin: '地劫',
  tiankong: '天空',
  tianxing: '天刑',
  tianyao: '天姚',
  jieshen: '解神',
  yinsha: '阴煞',
  tianxi: '天喜',
  tianguan: '天官',
  tianfu: '天福',
  tianku: '天哭',
  tianxu: '天虚',
  longchi: '龙池',
  fengge: '凤阁',
  hongluan: '红鸾',
  guchen: '孤辰',
  guasu: '寡宿',
  feilian: '蜚廉',
  posui: '破碎',
  taifu: '台辅',
  fenggao: '封诰',
  tianwu: '天巫',
  tianyue: '天月',
  santai: '三台',
  bazuo: '八座',
  engguang: '恩光',
  tiangui: '天贵',
  tiancai: '天才',
  tianshou: '天寿',
  jiekong: '截空',
  xunzhong: '旬中',
  xunkong: '旬空',
  kongwang: '空亡',
  jielu: '截路',
  yuede: '月德',
  tianshang: '天伤',
  tianshi: '天使',
  tianchu: '天厨',
  changsheng: '长生',
  muyu: '沐浴',
  guandai: '冠带',
  linguan: '临官',
  diwang: '帝旺',
  shuai: '衰',
  bing: '病',
  si: '死',
  mu: '墓',
  jue: '绝',
  tai: '胎',
  yang: '养',
  boshi: '博士',
  lishi: '力士',
  qinglong: '青龙',
  xiaohao: '小耗',
  jiangjun: '将军',
  zhoushu: '奏书',
  faylian: '飞廉',
  xishen: '喜神',
  bingfu: '病符',
  dahao: '大耗',
  fubing: '伏兵',
  guanfu: '官府',
  suijian: '岁建',
  huiqi: '晦气',
  sangmen: '丧门',
  guansuo: '贯索',
  gwanfu: '官符',
  longde: '龙德',
  baihu: '白虎',
  tiande: '天德',
  diaoke: '吊客',
  jiangxing: '将星',
  panan: '攀鞍',
  suiyi: '岁驿',
  xiishen: '息神',
  huagai: '华盖',
  jiesha: '劫煞',
  zhaisha: '灾煞',
  tiansha: '天煞',
  zhibei: '指背',
  xianchi: '咸池',
  yuesha: '月煞',
  wangshen: '亡神',
  yunkui: '运魁',
  yunyue: '运钺',
  yunchang: '运昌',
  yunqu: '运曲',
  yunluan: '运鸾',
  yunxi: '运喜',
  yunlu: '运禄',
  yunyang: '运羊',
  yuntuo: '运陀',
  yunma: '运马',
  liukui: '流魁',
  liuyue: '流钺',
  liuchang: '流昌',
  liuqu: '流曲',
  liuluan: '流鸾',
  liuxi: '流喜',
  liulu: '流禄',
  liuyang: '流羊',
  liutuo: '流陀',
  liuma: '流马',
  nianjie: '年解',
} as const;
